import moment from 'moment-timezone';
import { schema } from 'normalizr';
import { createSelector } from 'reselect';

import { create, getOne, getList } from '../modules/fetch';
import {
  createDenormalizeSelector,
  createAllEntitiesSelector,
} from '../modules/entities';

import { Organization, selectCurrentOrganization } from '../Organization';
import { Session } from '@app/api';
import {
  SESSION_ENTITY_NAME,
  sessionSchema,
  sessionLinkedEntities,
} from './schemas';
export interface SessionEntities {
  sessions: {
    [id: string]: Session;
  };
}

export const sendNotAvailableNotification = (
  sessionId: string,
  participant: any,
) =>
  create({
    payload: { participant },
    entity: 'notifications',
    path: `/public-sessions/${sessionId}/not-available-notification`,
  });

export const getPublicSession = (id: string) =>
  getOne<Session>({
    entity: SESSION_ENTITY_NAME,
    id,
    schema: sessionSchema,
    path: `/public-sessions/${id}`,
  });

export const getSessionForOrganization = (
  organizationId: string,
  params: Object = {},
) =>
  getList<Session>({
    entity: SESSION_ENTITY_NAME,
    path: `/organizations/${organizationId}/sessions`,
    schema: new schema.Array(sessionSchema),
    params,
  });

export const createSessionByIdSelector = () =>
  createDenormalizeSelector<Session>(sessionSchema, sessionLinkedEntities);

export const selectSessionForCurrentOrganization = createSelector(
  createAllEntitiesSelector<Session>(
    SESSION_ENTITY_NAME,
    sessionLinkedEntities,
    new schema.Array(sessionSchema),
  ),
  selectCurrentOrganization,
  (sessions: Session[], organization?: Organization): Session[] => {
    if (!organization || !organization.id) {
      return [];
    }
    return sessions
      .filter((session: Session) => session.organizationId === organization.id)
      .sort((a, b) => {
        if (a.archivedAt && !b.archivedAt) {
          return 1;
        }
        if (!a.archivedAt && b.archivedAt) {
          return -1;
        }
        return moment(b.updatedAt).diff(a.updatedAt);
      });
  },
);
